import React from "react";
import styles from "./MessageFeedbackNote.module.css";
import {FeedbackRating, MessageFeedbackUi} from "../../../../../../../api/generated";

interface MessageFeedbackNoteProps {
    feedback: MessageFeedbackUi
}

export const MessageFeedbackNote: React.FC<MessageFeedbackNoteProps> = ({feedback}) => {
    const isPositive = feedback.rating === FeedbackRating.Positive;

    return <div className={styles.wrapper}>
        <div className={isPositive ? styles.positive : styles.negative}>
            <span aria-hidden>{isPositive ? "👍" : "👎"}</span>
            <span>{isPositive ? "Helpful" : "Not helpful"}</span>
        </div>
        {feedback.comment && <div className={styles.comment}>“{feedback.comment}”</div>}
    </div>
}
